import Divider from 'flow/components/ui-components/Divider';
import Skeleton from 'flow/components/ui-components/Skeleton';

const SoftphoneIncomingCallsSkeleton = () => (
    <div className="animate-fade text-gray-200">
        <div className="flex h-13 items-center justify-between px-2">
            <Skeleton.Title className="w-36" />
            <div className="h-6 w-11 rounded-full bg-current" />
        </div>
        <Divider className="my-2" />
        <Skeleton.Title className="my-3 w-20 px-2" />
        <div className="flex items-center gap-x-3 px-2 py-1">
            <div className="size-6 rounded-full border-2 border-current" />
            <Skeleton.Title className="w-40" />
        </div>
        <div className="flex items-center gap-x-3 px-2 py-1">
            <div className="size-6 rounded-full border-2 border-current" />
            <Skeleton.Title className="w-52" />
        </div>
    </div>
);

export default SoftphoneIncomingCallsSkeleton;
